import { useEffect } from 'react';
import { useUploadFiles } from '../../../hooks';
import { FileStatus } from '../../../models';
import { displayNotification } from '../../../services';

export const NewTaskUploadFilesInBackground = ({
  attachedId,
  filesToUpload,
  setFilesToUpload,
}: {
  attachedId: number;
  filesToUpload: { file: File; status: FileStatus }[];
  setFilesToUpload: React.Dispatch<
    React.SetStateAction<
      {
        file: File;
        status: FileStatus;
      }[]
    >
  >;
}) => {
  const { setFiles, filesStatus } = useUploadFiles(attachedId);

  useEffect(() => {
    setFiles(filesToUpload);
    displayNotification({
      title: `Task Submitted & File(s) uploading in progress...`,
      description: `Currently uploading the submitted task files in the background.`,
    });
  }, []);

  useEffect(() => {
    if (filesStatus.length > 0) {
      const notCompletedFile = filesStatus.findIndex(
        file => file !== FileStatus.Completed
      );
      if (notCompletedFile === -1) {
        setFilesToUpload([]);
        displayNotification({
          title: `File(s) uploaded successfully`,
          description: `All the attached files are uploaded`,
        });
      }
    }
  }, [filesStatus]);

  return <div></div>;
};
